/* ════════════════════════════════════════════════════════════════
   STAR TONER · BRAND HERO BEHAVIOR · v6
   Hero visibility-pause + reveal-on-scroll stagger.
   Uses class selector (.cl-top-wrap--slim or .cl-top-wrap) so it
   works on collections, /pages/ofertas, /pages/Convi%C3%A9rtete-en-distribuidores, and
   any future page with the brand-aligned slim hero. Iterates over
   all matched heroes (typically 1 per page).
   Defer-loaded from theme.liquid for whitelisted templates.
   ════════════════════════════════════════════════════════════════ */
(function () {
  var heroes = document.querySelectorAll('#cl-hero-svc, .cl-top-wrap--slim, .cl-top-wrap');
  if (!heroes.length) return;

  var hasIO = 'IntersectionObserver' in window;

  heroes.forEach(function (hero) {
    if (hasIO) {
      /* Pause/resume CMYK or heat gradient when hero scrolls in/out of view */
      var visObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) hero.classList.add('cl-visible');
          else hero.classList.remove('cl-visible');
        });
      }, { threshold: 0.05 });
      visObs.observe(hero);

      /* Staggered reveal — fires once per element */
      var reveals = hero.querySelectorAll('.cl-reveal');
      var revObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = [].indexOf.call(reveals, e.target);
            setTimeout(function () { e.target.classList.add('on'); }, idx * 80);
            revObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { revObs.observe(el); });
    } else {
      hero.classList.add('cl-visible');
      hero.querySelectorAll('.cl-reveal').forEach(function (el) { el.classList.add('on'); });
    }
  });
})();
